import { isLitterTitle } from "@wags/discovery/pure.ts";
import { createSyncClientFlag } from "@/lib/core/client-flags/create-sync-client-flag";

const SHARE_OFFER_AFTER_SAVE_ENABLED = true;

export type ShareOfferProviderKind = "breeder" | "shelter";

export const useShareOfferEnabled = createSyncClientFlag({
    param: "shareOffer",
    key: "share-offer",
    env: SHARE_OFFER_AFTER_SAVE_ENABLED,
});

export function claimShareOffer(listingId: string): boolean {
    const key = `share-offer-shown:${listingId}`;
    try {
        if (window.localStorage.getItem(key) === "1") return false;
        window.localStorage.setItem(key, "1");
        return true;
    } catch {
        return true;
    }
}

export function shareOfferDogName(listing: {
    title?: string | null;
    numberOfMalesAvailable?: number | null;
    numberOfFemalesAvailable?: number | null;
}): string | null {
    const name = listing.title?.trim();
    if (!name || isLitterTitle(name)) return null;
    const mixedSexes =
        (listing.numberOfMalesAvailable ?? 0) > 0 &&
        (listing.numberOfFemalesAvailable ?? 0) > 0;
    return mixedSexes ? null : name;
}

export function shareOfferText(name: string | null): string {
    return name ? `${name} is saved` : "Saved";
}
